import { service } from ".";

export default {
  getAll: () => service.get("/groups"),
  getOne: (id) => service.get(`/groups/${id}`),
  create: (data) => service.post(`/groups`, data),
  update: (id, data) => service.put(`/groups/${id}`, data),
  delete: (id) => service.delete(`/groups/${id}`),
};
